/**
 * 빈 상태 (v2.317.0 · Salesforce 식 empty state).
 *
 *   - 한 줄 문구(무엇이 없는지 · 왜 그런지) + 단추 두 개 이하(다음에 할 일).
 *   - 「자료가 없습니다」 처럼 말을 끊지 않고, 「이 조건에 맞는 영업건이 없어요」 처럼 **무엇이** 없는지를 적는다.
 *   - 표 안에서는 <EmptyRow colSpan …> 로 한 줄을 차지한다.
 */
import type { ReactNode } from 'react';

export function EmptyState({
  title,
  hint,
  actions,
  className = '',
}: {
  /** 한 줄 — 「이 조건에 맞는 영업건이 없어요」 */
  title: string;
  /** 보조 한 줄(선택) — 「필터를 풀거나 다른 연도를 골라 보세요」 */
  hint?: string;
  /** 단추 두 개 이하 — 「필터 초기화」 「+ 영업건 등록」 */
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`py-10 px-4 text-center ${className}`}>
      <div className="text-sm text-slate-700">{title}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
      {actions && <div className="mt-3 flex flex-wrap items-center justify-center gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyRow({
  colSpan,
  title,
  hint,
  actions,
}: {
  colSpan: number;
  title: string;
  hint?: string;
  actions?: ReactNode;
}) {
  return (
    <tr>
      <td colSpan={colSpan} className="p-0">
        <EmptyState title={title} hint={hint} actions={actions} />
      </td>
    </tr>
  );
}
